module.exports = __webpack_public_path__ + "static/media/result-selected.785aaa3e.svg";